import { z } from 'zod';

export const MaropostListSuscriptionSchema = z.object({
  list_id: z.number().optional(),
  name: z.string().optional(),
  status: z.string().optional(),
  created_at: z.string().optional(),
  updated_at: z.string().optional(),
});

export type MaropostListSuscription = z.infer<
  typeof MaropostListSuscriptionSchema
>;

export const BoberdooLeadResponseSchema = z.object({
  lead: z.string().optional(),
  contacted: z.array(z.string()).optional(),
});

export type BoberdooLeadResponse = z.infer<typeof BoberdooLeadResponseSchema>;

export const BoberdooResponseSchema = z.object({
  leads: z.array(BoberdooLeadResponseSchema).optional(),
  message: z.string(),
  success: z.boolean(),
});

export type BoberdooResponse = z.infer<typeof BoberdooResponseSchema>;

export const DncRequestSchema = z.object({
  email: z.string(),
  product: z.string(),
  unsubscription_source: z.string(),
  unsubscribe_options: z.array(z.string()),
  feedback: z.string().optional(),
  severity: z.string().optional(),
});

export type DncRequest = z.infer<typeof DncRequestSchema>;

export const LeadSchema = z.object({
  Project: z.string().optional(),
  Token: z.string().optional(),
  Created: z.string().optional(),
  InCampaign: z.string().optional(),
  Transferred: z.boolean().optional(),
  Closed: z.boolean().optional(),
  Converted: z.boolean().optional(),
  DNCed: z.boolean().optional(),
});

export type Lead = z.infer<typeof LeadSchema>;

export const DripLeadResponseSchema = z.object({
  Leads: z.array(LeadSchema).optional(),
  ExternalCampaigns: z.number().optional(),
  ExternalCampaignsActive: z.number().optional(),
  Token: z.string().optional(),
  success: z.boolean(),
  ResponseCode: z.number().optional(),
  message: z.string(),
});

export type DripLeadResponse = z.infer<typeof DripLeadResponseSchema>;

export const BlueshiftResponseSchema = z.object({
  message: z.string(),
  success: z.boolean(),
});

export type BlueshiftResponse = z.infer<typeof BlueshiftResponseSchema>;

export const MaropostResponseSchema = z.object({
  lists: z.array(MaropostListSuscriptionSchema).optional(),
  message: z.string(),
  success: z.boolean(),
});

export type MaropostResponse = z.infer<typeof MaropostResponseSchema>;

export const DncResponseSchema = z.object({
  email: z.string(),
  product: z.string().nullable(),
  has_data: z.boolean().nullable(),
  unsubscription_source: z.string().nullable(),
  unsubscribe_options: z.array(z.string()).nullable(),
  feedback: z.string().nullable(),
  boberdoo: BoberdooResponseSchema.nullable(),
  maropost: MaropostResponseSchema.nullable(),
  drips: DripLeadResponseSchema.nullable(),
  severity: z.string().nullable(),
  blueshift: BlueshiftResponseSchema.nullable(),
  isSuccessful: z.boolean().optional(),
});

export type DncResponse = z.infer<typeof DncResponseSchema>;
